import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import ColonHydrology from "../pages/ColonHydrology";
import LymphaticDrainage from "../pages/LymphaticDrainage.jsx";
import LiverDetox from "../pages/LiverDetox.jsx";
import LocationsPage from "../pages/LocationsPage.jsx";
import ContactUs from "../pages/ContactUs.jsx";
import VishalContacts from "../components/VishalContacts.jsx";

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/colon-hydrology" element={<ColonHydrology />} />
    <Route path="/lymphatic-drainage" element={<LymphaticDrainage />} />
    <Route path="/liver-detox" element={<LiverDetox />} />
    <Route path="/Our-Location" element={<LocationsPage />} />
    <Route path="/ContactUs" element={<ContactUs />} />
    <Route path="/xlsxvishal" element={<VishalContacts />} />
  </Routes>
);

export default AppRouter;
